import { ReportResponseDto } from '@api/WhisApi/generated';
import { useState } from 'react';

interface UseReportSelectionResult {
  selectedReportIds: string[];
  selectedReports: ReportResponseDto[];
  handleSelectionChange: (
    selectedReportsOnPage: ReportResponseDto[],
    currentPageReports: ReportResponseDto[],
  ) => void;
  clearSelection: () => void;
}

export const useReportSelection = (): UseReportSelectionResult => {
  const [selectedReportsById, setSelectedReportsById] = useState<
    Record<string, ReportResponseDto>
  >({});

  const selectedReportIds = Object.keys(selectedReportsById);
  const selectedReports = Object.values(selectedReportsById);

  const handleSelectionChange = (
    selectedReportsOnPage: ReportResponseDto[],
    currentPageReports: ReportResponseDto[],
  ): void => {
    setSelectedReportsById((prev) => {
      const next = { ...prev };
      const currentIds = new Set(currentPageReports.map((report) => report.id));
      const selectedIds = new Set(
        selectedReportsOnPage.map((report) => report.id),
      );
      let hasChanges = false;

      currentIds.forEach((reportId) => {
        if (!selectedIds.has(reportId) && reportId in next) {
          delete next[reportId];
          hasChanges = true;
        }
      });

      selectedReportsOnPage.forEach((report) => {
        if (next[report.id] !== report) {
          next[report.id] = report;
          hasChanges = true;
        }
      });

      return hasChanges ? next : prev;
    });
  };

  const clearSelection = (): void => {
    setSelectedReportsById({});
  };

  return {
    selectedReportIds,
    selectedReports,
    handleSelectionChange,
    clearSelection,
  };
};
